import { Component, Inject, OnInit } from '@angular/core';
import { AbstractControl, UntypedFormArray, UntypedFormBuilder, UntypedFormGroup, ValidatorFn, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { CommonFieldsService } from 'app/laas/common-fields.service';
import { Observable } from 'rxjs';
import { ApplicantService } from 'app/laas/applicant.service';
import { AdminAuthService } from 'app/admin/admin-auth.service';
import { Router } from '@angular/router';
import { environment as ENV } from '../../../environments/environment';
import { LaasComponent } from '../laas.component';
import { OpenDialog } from '../dialog-for-cbs/dialog.component';
import { OpenDialogYesOrNo } from '../dialog-yes-or-no/dialog-yes-or-no.component';
import { CibilReportService } from '../financial/cibil-report/cibil-report.service';
import { RenewalInboxService } from 'app/admin/renewal-inbox/renewal-inbox.service';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import * as constants from "../../constant";

@Component({
  selector: 'wl-consent-disabled',
  template: `
  <h3 style='text-align:center;'>Are you Sure ?</h3>
  <p style='text-align:center;'>If you Choose Yes, you wont be able to proceed to further.!</p>
  <form style='padding-bottom:2rem' novalidate [formGroup]="otpForm"> 
  <mat-progress-bar *ngIf="isOtpVerifying"  mode="buffer"></mat-progress-bar> 
  <div style="display:flex;flex-direction:row;justify-content:center;align-items:center;">
     <wl-button style="flex:1 1 30%;" (click)="closeDialog()" >Continue</wl-button>
    <wl-button style="flex:1 1 30%;"   (click)="confirmkccdisable()">Yes</wl-button>
  </div>
  
  </form>
  `,

})

export class ConsentDisabledComponent {
  kcc_form_disable: boolean = false;

  otpForm: UntypedFormGroup;

  otp: any;
  isOtpVerifying: boolean;
  mobile: any;
  password: any;
  company: any;
  roleId: any;


  constructor(
    private fb: UntypedFormBuilder,
    private snackbar: MatSnackBar,
    public dialogRef: MatDialogRef<ConsentDisabledComponent>,
    private adminAuth: AdminAuthService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private admin: AdminAuthService
  ) {
    this.otpForm = this.fb.group({
      otpCode: ['',]
    })
    this.mobile = data.mobile;
    this.password = data.password
    this.roleId = data.roleId;
    console.log("Company " + JSON.stringify(data.mobile));


  }

  verify(val) {
    this.isOtpVerifying = true;
    console.log("otp ", val.otpCode);
    this.otp = val.otpCode;
    val.mobile = this.mobile;
    val.roleId = this.roleId;
    // this.admin.verifyOtp(this.mobile,this.otp,this.roleId).subscribe(resp => {
    this.admin.verifyOtp(this.mobile, this.otp).subscribe(resp => {

      this.isOtpVerifying = false;
      if (resp) {
        this.dialogRef.close(resp);
      } else {
        this.dialogRef.close(false);
      }
    })

  }
  closeDialog() {
    this.dialogRef.close({ data: true })

  }






  confirmkccdisable() {
    this.dialogRef.close({ data: 'yes confirmed' })
  }

}



@Component({
  selector: "wl-consent-form",
  templateUrl: "./consent-form.component.html",
  styles: [`
  .deleteIcon{
    /* font-size:28px;margin-top: 5px; */
    opacity: 0.6;
    cursor:pointer;
  }
  .deleteIcon:hover{
    /* font-size:30px;margin-top: 5px; */
    opacity: 1;
    cursor:pointer;
  }
  .deleteIcon:active {
    transform: translateY(-1px);
    box-shadow: 0 5px 10px rgba(0, 0, 0, 0.2);
    cursor:progress;
}
.form-fields-container {
  display: flex;
  flex-direction: column;
  gap: 16px; /* Adds space between each form field */
}

.form-field {
  display: flex;
  align-items: center;
}

.form-field label {
  width: 200px; /* Adjust the width as needed */
  margin-right: 16px; /* Space between label and form field */
  text-align: left; /* Align the label text to the right */
}

mat-form-field {
  width: 100%;
}


  `],
  providers: [CommonFieldsService, CibilReportService, RenewalInboxService],
})
export class ConsentFormComponent implements OnInit {
  detail: any;
  isDataPending = false;
  bankAccForm: UntypedFormGroup;
  multiCropDetailsForm: UntypedFormGroup;
  crops: Observable<any>;
  acre1: number = 0;
  acre2: number = 0;
  acre3: number = 0;
  acresum: String;
  consentformdata: any;
  kcc_form_disable: boolean = false;
  yeskcc: boolean = false;
  cropping_pattern: any;
  kcc_form_flag: boolean = false;
  yeskccrdbtn1: any;
  kharifdata: any;
  gunta1: any;
  gunta2: any;
  gunta3: any;
  acressum: number = 0;
  guntassum: number = 0;
  acressumnum: any = '0';
  newCrops: any;
  kharifDisabled: boolean = true;
  rabiDisabled: boolean = true;
  summerDisabled: boolean = true;
  proposedAmt: any = 0;
  isReportPending: boolean;
  reportLink: string;
  token: any;
  maker_checker_flag: boolean = false;
  role: string;
  roleId: number;
  loanAmountAsPerCbs: any;
  resp_cropping_pattern: any;
  disableSubmitFromMulticrop: boolean;
  acreOrHectare: string;
  showGuntas: boolean;
  totalLandArea: number;
  disableSubmitFromMulticropLR: boolean;
  hectaresKharif: number;
  hectaresRabi: number;
  hectaresSummer: number;
  rabiCropList: any;
  kharifCropList: any;
  rabiCropListNew: any[];
  rabiCropListNew2: any[];
  kharifCropListNew: any[];
  kharifCropListNew2: any[];
  showMPCroppingPattern: boolean;
  landRecordStatus: boolean = true;
  loading: boolean;
  stateCode: string;
  overAllStatus: any;
  consentFormText: string;
  repeatGetCreditScoreAPICount = 1;
  loadKACrops: boolean;
  loadAPCrops: boolean;
  pointerStyle: object;
  hideSubmit: boolean;
  district_ap: any;
  disabledByCreditCheck: boolean;
  disableSubmitConsentAlreadySubmitted: boolean;
  existing_limit: string | number = 0;
  grossAssesmentLimit: any;
  final_assed_limit: any;
  proposed_dp_k: number;
  sof_ofkrs: any;
  croparraydata: any[];
  landValuesArray: any;
  disableSentToCbsAlready: boolean;
  disableFailureInAssessmentStatus: boolean;
  accNoUnmasked: any;
  custId: any;
  consentUpdateStatus: boolean;
  fetchLandsResponse: any;
  disableSubmitBasedOnCropValidity: boolean = false;
  loanAmountInNumbers: any;
  loanAmountInDecimals: any;


  constructor(
    private fb: UntypedFormBuilder,
    private snackbar: MatSnackBar,
    private common: CommonFieldsService,
    private applicant: ApplicantService,
    private dialog: MatDialog,
    private router: Router,
    private laas: LaasComponent,
    private creditreport: CibilReportService,
    private renew: RenewalInboxService,
  ) {
    if (this.applicant.shouldIbeClicked()) {
      this.pointerStyle = { 'pointer-events': 'auto' }
    } else {
      this.pointerStyle = { 'pointer-events': 'none' }
    }

    this.bankAccForm = this.fb.group({
      bank_acc_no: ["", Validators.required],
      name_of_borrower: ["", Validators.required],
      name_of_co_applicant: [""],
      corps_address: ["", Validators.required],
      customer_id: ["", Validators.required],
      declaration: ["", Validators.required],
      rabi: [],
      summer: [],
      rabi_acres: [],
      summer_acres: [],
      type_of_facility: ["", Validators.required],
      existing_loan_in_lakhs: ["", Validators.required],
      outstanding_as_on: ["", Validators.required],
      roi: ["", Validators.required],
      margin: ["", Validators.required],
      acresum: ["",],
      due_date_of_renew: ["", Validators.required],
      type_of_facilities: ["", Validators.required],
      rate_of_interest: ["", Validators.required],
      minimum_margin: ["", Validators.required],
      securities: ["", Validators.required],
      kcc_loanamt_cbs: ["", Validators.required],
      is_renewal_kcc_limit_required: ["yes", Validators.required],
      is_cropping_insurance_required: ["yes", Validators.required],
      rabi_gunta: ["",],
      summer_gunta: ["",],
      acressumnum: [""],
      rabiId: [""],
      summerId: [""]
    });

    this.multiCropDetailsForm = this.fb.group({
      acressumnum: [""],
      kharifTotal: [''],
      rabiTotal: [''],
      summerTotal: [''],
      cropArrayKharif: this.fb.array([]),
      cropArrayRabi: this.fb.array([]),
      cropArraySummer: this.fb.array([]),
    })

    this.bankAccForm.controls['kcc_loanamt_cbs'].valueChanges.subscribe(newValue => {
      this.loanAmountAsPerCbs = this.bankAccForm.getRawValue().kcc_loanamt_cbs
    })

    this.multiCropDetailsForm.controls['acressumnum'].valueChanges.subscribe(newValue => {
      // window.alert(newValue)
      if (newValue > 0) {
        this.disableSubmitFromMulticrop = false
      } else {
        this.disableSubmitFromMulticrop = true
      }

      // this.bankAccForm.controls['kcc_loanamt_farmer'], Validators.compose([Validators.required, Validators.max(this.bankAccForm.getRawValue().kcc_loanamt_cbs)]);
    })


  }

  checkIfCropMatchesAndDisableSubmit(crops){
    console.log(crops, this.multiCropDetailsForm.valid);
    
    // kharifCropListNew2
    // rabiCropListNew2
    let cropArrayKharif
    if(crops.cropArrayKharif.length){
      // debugger
      
      if(crops && crops.cropArrayKharif && crops.cropArrayKharif[0] && crops.cropArrayKharif[0].kharif 
        && this.kharifCropListNew2 && this.kharifCropListNew2.length){
          cropArrayKharif = true;
        this.kharifCropListNew2.map((crop)=>{
          console.log(crop)
          if(crop.name.trim() == crops.cropArrayKharif[0].kharif.trim()){
            cropArrayKharif = false;
          }
        })
      }
      if(crops && crops.cropArrayKharif && crops.cropArrayKharif[1] && crops.cropArrayKharif[1].kharif 
        && this.kharifCropListNew2 && this.kharifCropListNew2.length){
          cropArrayKharif = true;
        this.kharifCropListNew2.map((crop)=>{
          console.log(crop)
          if(crop.name.trim() == crops.cropArrayKharif[1].kharif.trim()){
            cropArrayKharif = false;
          }
        })
      }
    }

    console.log(cropArrayKharif)

    let cropArrayRabi
    if(crops.cropArrayRabi.length){
      
      if(crops && crops.cropArrayRabi && crops.cropArrayRabi[0] && crops.cropArrayRabi[0].rabi 
        && this.rabiCropListNew2 && this.rabiCropListNew2.length){
        cropArrayRabi = true;
        this.rabiCropListNew2.map((crop)=>{
          console.log(crop)
          if(crop.name.trim() == crops.cropArrayRabi[0].rabi.trim()){
            cropArrayRabi = false;
          }
        })
      }
      if(crops && crops.cropArrayRabi && crops.cropArrayRabi[1] && crops.cropArrayRabi[1].rabi 
        && this.rabiCropListNew2 && this.rabiCropListNew2.length){
        cropArrayRabi = true;
        this.rabiCropListNew2.map((crop)=>{
          console.log(crop)
          if(crop.name.trim() == crops.cropArrayRabi[1].rabi.trim()){
            cropArrayRabi = false;
          }
        })
      }
    }


    console.log(cropArrayRabi)

    this.disableSubmitBasedOnCropValidity = (cropArrayKharif || cropArrayRabi);

  }

  getfinalsanctionamount(existing_limit, final_assed_limit) {
    return Math.min(existing_limit, final_assed_limit, this.loanAmountInNumbers);
  }

  getApplicantLoanFinalData(updateFinal) {
    let applicantId = sessionStorage.getItem('wl-applicant-id');
    let payload = { applicantId };
    this.loading = true;
    this.applicant
      .getApplicantLoanFinalData(payload)
      .subscribe((resp) => {
        this.loading = false;
        if (resp && resp.success && resp.message && resp.message == "success") {

          let user_docs = resp.result.user_docs;
          if (user_docs && user_docs.existing_loan_details && user_docs.existing_loan_details.existing_limit) {
            this.existing_limit = user_docs.existing_loan_details.existing_limit;
          }

          if (resp && resp.result && resp.result.cropping_details.grossAssesmentLimit) {
            this.grossAssesmentLimit = resp.result.cropping_details.grossAssesmentLimit;
            this.final_assed_limit = resp.result.cropping_details.grossAssesmentLimit;

            this.proposed_dp_k = Math.round(
              this.getfinalsanctionamount(
                this.existing_limit,
                this.final_assed_limit
              )
            );
          }

          if (resp && resp.result && resp.result.final_form_submitted_data.sof_ofkrs) {
            this.sof_ofkrs = resp.result.final_form_submitted_data.sof_ofkrs;
          }

          let crop_data = resp.result.final_form_submitted_data.croparraydata;
          this.croparraydata = []
          for (let i = 0; i < crop_data.length; i++) {

            if (crop_data[i].crop_name) {
              let obj = {};
              obj['crop_season'] = crop_data[i].crop_season ? crop_data[i].crop_season : "",
                obj['crop_name'] = crop_data[i].crop_name ? crop_data[i].crop_name : "",
                obj['area'] = crop_data[i].area ? crop_data[i].area : "",
                obj['scal_of_fin'] = crop_data[i].scal_of_fin ? crop_data[i].scal_of_fin : "",
                obj['loan_amount'] = crop_data[i].loan_amount ? crop_data[i].loan_amount : "",
                obj['add_sof_percent'] = crop_data[i].add_sof_percent ? crop_data[i].add_sof_percent : null,
                obj['add_sof_amt'] = crop_data[i].add_sof_amt ? crop_data[i].add_sof_amt : 0;
              this.croparraydata.push(obj)
            }
          }

          if (resp && resp.result && resp.result.final_form_submitted_data && resp.result.final_form_submitted_data.land_value) {
            this.landValuesArray = resp.result.final_form_submitted_data.land_value;
          }

          let dataobj = {
            annexure_data: {
              land_value: this.landValuesArray,
              nameofthemaker: "NA",
              empIdofmaker: "NA",
              dateofmaker: new Date(),
              nameofthechecker: "NA",
              empIdofchecker: "NA",
              dateofchecker: new Date(),
              proposed_sof_ro: 0,
              final_assed_limit: this.final_assed_limit,
              proposed_dp_k: this.proposed_dp_k,
              sof_ofkrs: this.sof_ofkrs,
              croparraydata: this.croparraydata,
            },
            approval_status: "approved",
            userId: sessionStorage.getItem("wl-admin-id"),
          };

          if (this.existing_limit <= this.final_assed_limit) {
            dataobj['assesment_status'] = "success";
          } else if (this.existing_limit > this.final_assed_limit) {
            dataobj['assesment_status'] = "failure";
          }

          this.loading = true;
          if (updateFinal) {
            this.applicant.updateApplicantFinalAnnexureData(dataobj).subscribe((resp) => {
              console.log("resp " + JSON.stringify(resp));
              this.loading = false;
              if (resp && resp.success) {
                if (this.existing_limit <= this.final_assed_limit) {
                  this.sendToCbs()
                } else if (this.existing_limit > this.final_assed_limit) {
                  this.reject()
                }
              }
            }, (err) => {
              this.loading = false;
              this.snackbar.open(constants.FAILED_TO_SUBMIT_DATA, "OK", { duration: 3000 })
            })
          } else {
            if (resp && resp.success) {
              if (this.existing_limit <= this.final_assed_limit) {
                this.sendToCbs()
              } else if (this.existing_limit > this.final_assed_limit) {
                this.reject()
              }
            }
          }

        }

      }, (err) => {
        this.snackbar.open(constants.FAILED_TO_GET_LOAN_INFORMATION, "OK", { duration: 3000 })
      })
  }

  sendToCbs() {
    this.loading = true;
    let id = this.custId;
    let name = this.bankAccForm.getRawValue().name_of_borrower;
    let accNo = this.accNoUnmasked;
    // let formdata = this.loanRenewalForm.getRawValue()
    if (id && name && accNo) {
      if (this.existing_limit <= this.final_assed_limit) {
        this.renew.sendToCbs(id, name, accNo).subscribe(resp => {
          console.log(resp)
          this.loading = false;
          if (resp && resp.respMessage && resp.respMessage.message && resp.respMessage.message == "success") {
            // this.snackbar.open('Sent to CBS successfully', 'OK',{duration:3000})
            this.disableSentToCbsAlready = true;

            const dialogRef = this.dialog.open(OpenDialogYesOrNo, {
              width: 'auto', height: 'auto',
              data: { heading: constants.SENT_TOCBS_SUCCESS, content: constants.DOWNLOAD_DES, button1Text: "Yes", button2Text: "No" }
            });

            dialogRef.afterClosed().subscribe(res => {
              console.log(res)
              if (res == "close") {
                window.close()
              } else {
                // this.ngOnInit()
              }
            })

          } else {
            const dialogRef = this.dialog.open(OpenDialogYesOrNo, {
              width: 'auto', height: 'auto',
              data: { heading: constants.FAIL_TO_SENDCBS, content: "", button1Text: "OK" }
            });
            dialogRef.afterClosed().subscribe((resp) => {
              // this.router.navigateByUrl('/laas/bre-status', { skipLocationChange: true }).then(() => {
              // })
            })
          }
          // this.ngOnInit()
        }, (err) => {
          this.loading = false;
          const dialogRef = this.dialog.open(OpenDialogYesOrNo, {
            width: 'auto', height: 'auto',
            data: { heading: constants.FAIL_TO_SENDCBS, content: "", button1Text: "OK" }
          });
          dialogRef.afterClosed().subscribe((resp) => {
            // this.router.navigateByUrl('/laas/bre-status', { skipLocationChange: true }).then(() => {
            // })
          })
        })
      } else {
        console.log("Final assessed limit < E DP")
      }

    }
  }

  reject() {
    this.loading = true;
    let id = this.getApplicantID();
    this.applicant.rejectLoan(id).subscribe(resp => {
      this.loading = false;
      if (resp && resp.success) {
        console.log(resp)
        this.disableSentToCbsAlready = true;
        // this.snackbar.open("The Applicant is rejected","OK",{duration:3000})
        // this.router.navigateByUrl('/laas/bre-status', { skipLocationChange: true }).then(() => {
        //   this.router.navigate(['/laas/applications/loan-renewal-form']);
        const dialogRef = this.dialog.open(OpenDialogYesOrNo, {
          width: 'auto', height: 'auto',
          data: { heading: constants.CASE_REJECTED, content: constants.CASE_SHIFTED_TO_FAILUREBOX, button1Text: "Yes", button2Text: "No" }
        });

        dialogRef.afterClosed().subscribe(res => {
          console.log(res)
          if (res == "close") {
            window.close()
          } else {
            // this.ngOnInit()
          }
        })
        // })
      } else {
        const dialogRef = this.dialog.open(OpenDialogYesOrNo, {
          width: 'auto', height: 'auto',
          data: { heading: constants.REJECT_FAILED , content: "", button1Text: "OK" }
        });
        dialogRef.afterClosed().subscribe((resp) => {
          // this.router.navigateByUrl('/laas/bre-status', { skipLocationChange: true }).then(() => {
          // })
        })
      }

    }, (err) => {
      this.loading = false;
      const dialogRef = this.dialog.open(OpenDialogYesOrNo, {
        width: 'auto', height: 'auto',
        data: { heading: constants.REJECT_FAILED, content: "", button1Text: "OK" }
      });
      dialogRef.afterClosed().subscribe((resp) => {
        // this.router.navigateByUrl('/laas/bre-status', { skipLocationChange: true }).then(() => {
        // })
      })
    })
  }

  consoleIt() {
    console.log(this.bankAccForm.getRawValue())
  }

  // async ngOnInit() {
  //   this.loading = true

  //   this.setStateValuesOnLoad();

  //   this.applicant.getOverAllStatus().subscribe(resp => {
  //     console.log(resp)
  //     this.loading = true;
  //     this.overAllStatus = resp
  //     if (resp && resp.data && resp.data.landDetails) {

  //       if (resp.data && resp.data.cicReport == false) {
  //         this.applicant.getCreditData(this.stateCode, this.repeatGetCreditScoreAPICount).subscribe(resp => {
  //           console.log("getcreditdata ---> API", resp)
  //           if (
  //             resp &&
  //             resp.success == true &&
  //             (resp.message == "Report Generated Successfully" ||
  //               resp.message == "Credit Report fetched successfully")
  //           ) {
  //             this.loading = false;
  //             if (resp.npaStatusFlag && resp.npaStatusFlag == true) {
  //               this.openCreditDataModal("NPA Status Found")
  //               // this.snackbar.open('NPA status found', 'OK', { duration: 3000 })
  //             } else {
  //               this.loading = true;
  //               this.creditreport.getBreStatus().subscribe(result => {
  //                 this.loading = false;
  //                 console.log(result);
  //                 // result = "Failure"
  //                 if (result == "Failure" || result == "failure") {
  //                   this.consentFormText = "The customer file has been moved to Failure Box."
  //                   this.landRecordStatus = false
  //                 } else if (result == "Success" || result == "success") {
  //                   // this.landRecordStatus = true
  //                 } else if (result == "pending" || result == "Pending") {
  //                   this.consentFormText = "Please generate credit bureau for the customer."
  //                   this.landRecordStatus = false
  //                 }
  //               }, (err) => {
  //                 this.snackbar.open("Failed to fetch BRE information", "OK", { duration: 3000 })
  //               })
  //             }
  //           } else {
  //             this.repeatGetCreditScoreAPICount =
  //               this.repeatGetCreditScoreAPICount + 1;
  //             this.loading = true;
  //             this.applicant.getCreditData(this.stateCode, this.repeatGetCreditScoreAPICount).subscribe(resp => {
  //               console.log("getcreditdata ---> API", resp)
  //               if (
  //                 resp &&
  //                 resp.success == true &&
  //                 (resp.message == "Report Generated Successfully" ||
  //                   resp.message == "Credit Report fetched successfully")
  //               ) {
  //                 this.loading = false;
  //                 if (resp.npaStatusFlag && resp.npaStatusFlag == true) {
  //                   this.snackbar.open('NPA status found', 'OK', { duration: 3000 })
  //                 } else {
  //                   this.loading = true;
  //                   this.creditreport.getBreStatus().subscribe(result => {
  //                     console.log(result);
  //                     this.loading = false;
  //                     // result = "Failure"
  //                     if (result == "Failure" || result == "failure") {
  //                       this.consentFormText = "The customer file has been moved to Failure Box."
  //                       this.landRecordStatus = false
  //                     } else if (result == "Success" || result == "success") {
  //                       // this.landRecordStatus = true
  //                     } else if (result == "pending" || result == "Pending") {
  //                       this.consentFormText = "Please generate credit bureau for the customer."
  //                       this.landRecordStatus = false
  //                     }
  //                   }, (err) => {
  //                     this.snackbar.open("Failed to fetch BRE information", "OK", { duration: 3000 })
  //                   })
  //                 }
  //               } else {
  //                 this.loading = false;
  //                 if (resp && resp.moreInfo && resp.moreInfo.errormsg) {
  //                   this.openCreditDataModal(resp.moreInfo.errormsg)
  //                   // this.snackbar.open(resp.moreInfo.errormsg, 'OK', { duration: 3000 })
  //                 } else if (resp && resp.message) {
  //                   this.openCreditDataModal(resp.message)
  //                   // this.snackbar.open(resp.message, 'OK', { duration: 3000 })
  //                 }
  //                 else {
  //                   this.openCreditDataModal("Failed at credit check")
  //                   // this.snackbar.open('Failed at credit check', 'OK', { duration: 3000 })
  //                 }

  //               }
  //             })
  //           }

  //         })
  //       }
  //     } else {
  //       this.loading = false;
  //       this.consentFormText = "Please fill the Land Details for the customer."
  //       this.landRecordStatus = false
  //     }
  //   })

  //   let applicantId = sessionStorage.getItem('wl-applicant-id'); // "61a5d6ed9f098731f40fb02d";//urlvalue.split("/")[4];
  //   let payload = { applicantId };

  //   console.log(this.crops, "cropsss");
  //   this.consentformdata = this.applicant
  //     .getconsentformdata(payload).subscribe((resp) => {
  //       this.loading = false
  //       console.log(
  //         "response from getconsentformdata 54645" + JSON.stringify(resp)
  //       );
  //       if (resp && resp.success) {


  //         // console.log(
  //         //   "response from getconsentformdata",
  //         //   resp.result.user_docs.coapplicant_data
  //         // );
  //         let user_docs = resp && resp.result && resp.result.user_docs ? resp.result.user_docs : null;
  //         let resp_cropping_pattern = resp && resp.result && resp.result.cropping_pattern ? resp.result.cropping_pattern : null;
  //         let croppingPattern = resp && resp.result && resp.result.cropping_pattern ? resp.result.cropping_pattern : null;
  //         this.resp_cropping_pattern = resp_cropping_pattern
  //         let consentFd_resp_result = resp.result;


  //         if (user_docs && user_docs.existing_loan_details && user_docs.existing_loan_details.existing_limit) {
  //           this.existing_limit = user_docs.existing_loan_details.existing_limit;
  //         }
  //         if (user_docs && user_docs.kcc_acc_no_referencenumber) {
  //           this.accNoUnmasked = user_docs.kcc_acc_no_referencenumber;
  //         }

  //         if (user_docs && user_docs.custId) {
  //           this.custId = user_docs.custId;
  //         }

  //         if (resp && resp.result && resp.result.cropping_pattern && resp.result.cropping_pattern[0] && resp.result.cropping_pattern[0].crop_data) {
  //           for (let i = 0; i < resp_cropping_pattern[0].crop_data.length; i++) {
  //             if (resp_cropping_pattern && resp_cropping_pattern[0] && resp_cropping_pattern[0].crop_data && resp_cropping_pattern[0].crop_data[i] && resp_cropping_pattern[0].crop_data[i].name_of_the_crop) {
  //               (this.multiCropDetailsForm.controls.cropArrayKharif as FormArray).push(this.fb.group({
  //                 kharif: [resp_cropping_pattern[0].crop_data[i].name_of_the_crop.crop_name ? resp_cropping_pattern[0].crop_data[i].name_of_the_crop.crop_name : ""],
  //                 kharifId: [resp_cropping_pattern[0].crop_data[i].name_of_the_crop.id ? resp_cropping_pattern[0].crop_data[i].name_of_the_crop.id : ""],
  //                 kharif_acres: [resp_cropping_pattern[0].crop_data[i].acres ? resp_cropping_pattern[0].crop_data[i].acres : ""],
  //                 kharif_guntas: [resp_cropping_pattern[0].crop_data[i].guntas ? resp_cropping_pattern[0].crop_data[i].guntas : ""],
  //               }))
  //             }
  //           }
  //         }

  //         if (resp && resp.result && resp.result.cropping_pattern && resp.result.cropping_pattern[1] && resp.result.cropping_pattern[1].crop_data) {
  //           for (let i = 0; i < resp_cropping_pattern[1].crop_data.length; i++) {
  //             if (resp_cropping_pattern && resp_cropping_pattern[1] && resp_cropping_pattern[1].crop_data && resp_cropping_pattern[1].crop_data[i] && resp_cropping_pattern[1].crop_data[i].name_of_the_crop) {
  //               (this.multiCropDetailsForm.controls.cropArrayRabi as FormArray).push(this.fb.group({
  //                 rabi: [resp_cropping_pattern[1].crop_data[i].name_of_the_crop.crop_name ? resp_cropping_pattern[1].crop_data[i].name_of_the_crop.crop_name : ""],
  //                 rabiId: [resp_cropping_pattern[1].crop_data[i].name_of_the_crop.id ? resp_cropping_pattern[1].crop_data[i].name_of_the_crop.id : ""],
  //                 rabi_acres: [resp_cropping_pattern[1].crop_data[i].acres ? resp_cropping_pattern[1].crop_data[i].acres : ""],
  //                 rabi_gunta: [resp_cropping_pattern[1].crop_data[i].guntas ? resp_cropping_pattern[1].crop_data[i].guntas : ""],
  //               }))
  //             }
  //           }
  //         }

  //         if (resp && resp.result && resp.result.cropping_pattern && resp.result.cropping_pattern[2] && resp.result.cropping_pattern[2].crop_data) {
  //           for (let i = 0; i < resp_cropping_pattern[2].crop_data.length; i++) {
  //             if (resp_cropping_pattern && resp_cropping_pattern[2] && resp_cropping_pattern[2].crop_data && resp_cropping_pattern[2].crop_data[i] && resp_cropping_pattern[2].crop_data[i].name_of_the_crop) {
  //               (this.multiCropDetailsForm.controls.cropArraySummer as FormArray).push(this.fb.group({
  //                 summer: [resp_cropping_pattern[2].crop_data[i].name_of_the_crop.crop_name ? resp_cropping_pattern[2].crop_data[i].name_of_the_crop.crop_name : ""],
  //                 summerId: [resp_cropping_pattern[2].crop_data[i].name_of_the_crop.id ? resp_cropping_pattern[2].crop_data[i].name_of_the_crop.id : ""],
  //                 summer_acres: [resp_cropping_pattern[2].crop_data[i].acres ? resp_cropping_pattern[2].crop_data[i].acres : ""],
  //                 summer_gunta: [resp_cropping_pattern[2].crop_data[i].guntas ? resp_cropping_pattern[2].crop_data[i].guntas : ""],
  //               }))
  //             }
  //           }
  //         }


  //         this.totalacres();
  //         { // patching values only here'
  //           console.log(resp.result.user_docs)
  //           this.bankAccForm.patchValue({
  //             name_of_borrower: user_docs.applicant_name ? user_docs.applicant_name : "",
  //           });
  //           this.bankAccForm.patchValue({
  //             name_of_co_applicant: (resp.result.user_docs.coapplicant_data && resp.result.user_docs.coapplicant_data.name)
  //               ? resp.result.user_docs.coapplicant_data.name
  //               : "",
  //           });
  //           this.bankAccForm.patchValue({
  //             bank_acc_no: user_docs.kcc_acc_no ? user_docs.kcc_acc_no : "",
  //           });
  //           this.bankAccForm.patchValue({
  //             corps_address: user_docs.resAdd ? user_docs.resAdd.address + ', ' + user_docs.resAdd.state + ', ' + user_docs.resAdd.postal_code : "",
  //           });
  //           this.bankAccForm.patchValue({
  //             customer_id: user_docs.custId ? user_docs.custId : "",
  //           });
  //           this.bankAccForm.patchValue({
  //             due_date_of_renew: user_docs.renewal_duedate_for_credit_limit
  //               ? user_docs.renewal_duedate_for_credit_limit
  //               : "",
  //           });
  //           this.bankAccForm.patchValue({
  //             type_of_facility: user_docs.existing_loan_details.type_of_facility
  //               ? user_docs.existing_loan_details.type_of_facility
  //               : "",
  //           });
  //           this.bankAccForm.patchValue({
  //             existing_loan_in_lakhs: user_docs.existing_dp
  //               ? user_docs.existing_dp
  //               : "",
  //           });
  //           this.bankAccForm.patchValue({
  //             outstanding_as_on: user_docs.existing_loan_details.outstanding_as_on
  //               ? user_docs.existing_loan_details.outstanding_as_on
  //               : 0,
  //           });
  //           this.bankAccForm.patchValue({
  //             roi: user_docs.existing_loan_details.roi
  //               ? user_docs.existing_loan_details.roi
  //               : "",
  //             rate_of_interest: user_docs.existing_loan_details.roi
  //               ? user_docs.existing_loan_details.roi
  //               : ""
  //           });
  //           this.bankAccForm.patchValue({
  //             margin: user_docs.existing_loan_details.margin
  //               ? user_docs.existing_loan_details.margin
  //               : "",
  //             minimum_margin: user_docs.existing_loan_details.margin
  //               ? user_docs.existing_loan_details.margin
  //               : "",
  //           });
  //           this.bankAccForm.patchValue({
  //             type_of_facilities:
  //               user_docs.existing_loan_details && user_docs.existing_loan_details.type_of_facility
  //                 ? user_docs.existing_loan_details.type_of_facility
  //                 : "",
  //           });

  //           this.bankAccForm.patchValue({
  //             securities: "Hypothecation of Standing Crops and other Securities as per existing terms of sanction.",
  //           });
  //           this.bankAccForm.patchValue({
  //             kcc_loanamt_cbs:
  //               user_docs.existing_dp
  //                 ? user_docs.existing_dp
  //                 : "",
  //           });
  //           this.bankAccForm.patchValue({
  //             is_renewal_kcc_limit_required: consentFd_resp_result.is_renewal_kcc_limit_required && (consentFd_resp_result.is_renewal_kcc_limit_required != "pending")
  //               ? consentFd_resp_result.is_renewal_kcc_limit_required
  //               : "yes",
  //           });
  //           this.bankAccForm.patchValue({
  //             is_cropping_insurance_required: consentFd_resp_result.is_cropping_insurance_required && (consentFd_resp_result.is_cropping_insurance_required != "pending")
  //               ? consentFd_resp_result.is_cropping_insurance_required
  //               : "yes",
  //           });

  //         }
  //         this.loanAmountAsPerCbs = user_docs.existing_dp
  //           ? user_docs.existing_dp
  //           : "";

  //         console.log(resp_cropping_pattern, "resp_cropping_pattern");

  //         if (resp && resp.result && resp.result.consent_update_status && resp.result.consent_update_status == true) {
  //           // this.disableSubmitConsentAlreadySubmitted = true;
  //           if (resp && resp.result && resp.result.sent_to_cbs && resp.result.sent_to_cbs == true) {
  //             this.disableSentToCbsAlready = true;
  //           } else {
  //             if (resp && resp.result && resp.result.final_form_submitted_status && resp.result.final_form_submitted_status.toLowerCase() == "yes") {
  //               if (resp && resp.result && resp.result.assesment_status && resp.result.assesment_status.toLowerCase() == "success") {
  //                 this.getApplicantLoanFinalData(false);
  //               } else if (resp && resp.result && resp.result.assesment_status && resp.result.assesment_status.toLowerCase() == "failure") {
  //                 this.disableFailureInAssessmentStatus = true;
  //                 this.snackbar.open("Assessment failure. Moved to failure box.", "OK", { duration: 3000 })
  //               } else if (resp && resp.result && resp.result.assesment_status && resp.result.assesment_status.toLowerCase() == "pending") {
  //                 this.getApplicantLoanFinalData(true);
  //               }
  //             } else if ((resp.result.final_form_submitted_status.toLowerCase() == "no") || (resp.result.final_form_submitted_status.toLowerCase() == "pending")) {
  //               this.getApplicantLoanFinalData(true);
  //             }
  //           }
  //         } else {
  //           // this.snackbar.open("Please submit the consent form", "OK", { duration: 3000 })
  //           this.consentUpdateStatus = false;
  //         }

  //         this.applicant.getLandDetails().subscribe(resp => {
  //           console.log(resp)
  //           let totalArea = 0;
  //           if (resp && resp.files && resp.files.length && resp.files[0] && resp.files[0].district_eng) {
  //             this.district_ap = resp.files[0].district_eng
  //           }

  //           if (resp && resp.files) {

  //             if (resp && resp.landSubmitStatus && resp.landSubmitStatus == true) {
  //               console.log('if');
  //               this.landRecordStatus = true;
  //               !this.consentUpdateStatus ? this.snackbar.open("Please submit the consent form", "OK", { duration: 3000 }) : "";
  //             } else {
  //               console.log('else');
  //               this.landRecordStatus = false;
  //               this.consentFormText = "Land record updation pending. Please add land records and click on Submit."
  //             }

  //             if (this.showMPCroppingPattern && this.landRecordStatus) {
  //               for (let i = 0; i < resp.files.length; i++) {
  //                 totalArea = totalArea + resp.files[i].land_details.landParcelDetails[0].surveyNoArea[0] * 1
  //               }

  //               this.totalLandArea = Math.round(totalArea * 100) / 100

  //               this.multiCropDetailsForm.controls['kharifTotal'].setValidators([Validators.max(this.totalLandArea)]);
  //               this.multiCropDetailsForm.controls['rabiTotal'].setValidators([Validators.max(this.totalLandArea)]);
  //               this.multiCropDetailsForm.controls['summerTotal'].setValidators([Validators.max(this.totalLandArea)]);

  //               console.log(this.totalLandArea, "total land area *******")

  //               let distid
  //               distid = resp.files[0] && resp.files[0].DistId ? resp.files[0].DistId : ""
  //               let data = { distId: distid }
  //               this.applicant.getcropsdataDistId(data).subscribe((res) => {
  //                 console.log(res, "ressssssssssssssssssssss");
  //                 this.loading = false
  //                 this.crops = res;
  //                 this.rabiCropList = res.rabi;
  //                 this.kharifCropList = res.kharif;
  //                 console.log(this.rabiCropList, this.kharifCropList);
  //                 if (this.rabiCropList.length > 0) {

  //                   let reformattedArrayRabi = this.rabiCropList.map(obj => {
  //                     let rObj = {}

  //                     rObj["name"] = obj.crop_name;
  //                     rObj["id"] = obj.id;
  //                     rObj["rainfed"] = obj.rainfed;
  //                     rObj["irrigated"] = obj.irrigated;

  //                     return rObj
  //                   })
  //                   console.log(this.rabiCropListNew2)
  //                   this.rabiCropListNew2 = reformattedArrayRabi.filter(  //CROPS for MP Rabi
  //                     (r) => r.name != "-"
  //                   );
  //                 } else {
  //                   this.rabiCropListNew2 = []
  //                   this.snackbar.open('No Rabi crops found', 'OK', { duration: 3000 })
  //                 }

  //                 if (this.kharifCropList.length > 0) {
  //                   let reformattedArrayKharif = this.kharifCropList.map(obj => {
  //                     let rObj = {}

  //                     rObj["name"] = obj.crop_name;
  //                     rObj["id"] = obj.id;
  //                     rObj["rainfed"] = obj.rainfed;
  //                     rObj["irrigated"] = obj.irrigated;

  //                     return rObj
  //                   })
  //                   console.log(this.rabiCropListNew2)
  //                   this.kharifCropListNew2 = reformattedArrayKharif.filter(  //CROPS for MP Rabi
  //                     (r) => r.name != "-"
  //                   );
  //                 } else {
  //                   this.kharifCropListNew2 = []
  //                   this.snackbar.open('No kharif crops found', 'OK', { duration: 3000 })
  //                 }

  //               });
  //             }

  //             if (this.loadKACrops && this.landRecordStatus) {
  //               for (let i = 0; i < resp.files.length; i++) {
  //                 totalArea = totalArea + resp.files[i].bhoomi_details.Landdata[0].ExtAcre * 1 + resp.files[i].bhoomi_details.Landdata[0].ExtGunta / 40;
  //               }

  //               this.totalLandArea = Math.round(totalArea * 100) / 100

  //               this.multiCropDetailsForm.controls['kharifTotal'].setValidators([Validators.max(this.totalLandArea)]);
  //               this.multiCropDetailsForm.controls['rabiTotal'].setValidators([Validators.max(this.totalLandArea)]);
  //               this.multiCropDetailsForm.controls['summerTotal'].setValidators([Validators.max(this.totalLandArea)]);

  //               console.log(this.totalLandArea, "total land area *******")

  //               let distid
  //               distid = resp && resp.files && resp.files[0] && resp.files[0].bhoomi_details && resp.files[0].bhoomi_details.Landdata && resp.files[0].bhoomi_details.Landdata[0] && resp.files[0].bhoomi_details.Landdata[0].DistrictName ? resp.files[0].bhoomi_details.Landdata[0].DistrictName : "";

  //               this.multiCropDetailsForm.controls['kharifTotal'].setValidators([Validators.max(this.totalLandArea)]);
  //               this.multiCropDetailsForm.controls['rabiTotal'].setValidators([Validators.max(this.totalLandArea)]);
  //               this.multiCropDetailsForm.controls['summerTotal'].setValidators([Validators.max(this.totalLandArea)]);



  //               if (distid) {
  //                 let data = { distId: distid }
  //                 this.applicant.getcropsdataDistId(data).subscribe((res) => {
  //                   console.log(res, "ressssssssssssssssssssss");
  //                   // res = cropsResp;
  //                   // res = cropsfromuat;
  //                   this.loading = false
  //                   this.crops = res;
  //                   this.rabiCropList = res.rabi;
  //                   this.kharifCropList = res.kharif;
  //                   console.log(this.rabiCropList, this.kharifCropList);
  //                   if (this.rabiCropList.length > 0) {
  //                     let reformattedArrayRabi = this.rabiCropList.map(obj => {
  //                       let rObj = {}

  //                       rObj["name"] = obj.crop_name;
  //                       rObj["id"] = obj.id;
  //                       rObj["rainfed"] = obj.rainfed;
  //                       rObj["irrigated"] = obj.irrigated;

  //                       return rObj
  //                     })
  //                     console.log(this.rabiCropListNew2)
  //                     this.rabiCropListNew2 = reformattedArrayRabi.filter(  //CROPS for MP Rabi
  //                       (r) => r.name != "-"
  //                     );

  //                   } else {
  //                     this.rabiCropListNew2 = []
  //                     this.snackbar.open('No Rabi crops found', 'OK', { duration: 3000 })
  //                   }

  //                   if (this.kharifCropList.length > 0) {
  //                     let reformattedArrayKharif = this.kharifCropList.map(obj => {
  //                       let rObj = {}

  //                       rObj["name"] = obj.crop_name;
  //                       rObj["id"] = obj.id;
  //                       rObj["rainfed"] = obj.rainfed;
  //                       rObj["irrigated"] = obj.irrigated;

  //                       return rObj
  //                     })
  //                     console.log(this.rabiCropListNew2)
  //                     this.kharifCropListNew2 = reformattedArrayKharif.filter(  //CROPS for MP Rabi
  //                       (r) => r.name != "-"
  //                     );
  //                   } else {
  //                     this.kharifCropListNew2 = []
  //                     this.snackbar.open('No Kharif crops found', 'OK', { duration: 3000 })
  //                   }


  //                 });
  //               } else {
  //                 this.snackbar.open("Couldn't find District Information to get crops list", "OK", { duration: 3000 })
  //               }

  //             }

  //             if (this.loadAPCrops && this.landRecordStatus && this.district_ap) {
  //               console.log('ap da')
  //               for (let i = 0; i < resp.files.length; i++) {
  //                 totalArea = totalArea + resp.files[i].landParcelDetails[0].Total_Extent * 1
  //               }

  //               this.totalLandArea = Math.round(totalArea * 100) / 100

  //               this.multiCropDetailsForm.controls['kharifTotal'].setValidators([Validators.max(this.totalLandArea)]);
  //               this.multiCropDetailsForm.controls['rabiTotal'].setValidators([Validators.max(this.totalLandArea)]);
  //               this.multiCropDetailsForm.controls['summerTotal'].setValidators([Validators.max(this.totalLandArea)]);

  //               console.log(this.totalLandArea, "total land area *******")
  //               let distid
  //               distid = resp && resp.files && resp.files[0] && resp.files[0].DistId ? resp.files[0].DistId : "";
  //               let data = { distId: this.district_ap }
  //               // this.applicant.getcropsdataDistId(data).subscribe((res) => {
  //               this.applicant.getCropsList(data).subscribe((res) => {
  //                 console.log(res, "ressssssssssssssssssssss");

  //                 this.loading = false

  //                 let crops = res && res.crops_list ? res.crops_list : "";
  //                 this.rabiCropList = crops.filter((crop) => {
  //                   return crop.season == "RABI"
  //                 })
  //                 this.kharifCropList = crops.filter((crop) => {
  //                   return crop.season == "KHARIF"
  //                 })
  //                 // if (this.rabiCropList != null) {
  //                 if (crops.length > 0) {
  //                   let reformattedArrayRabi = crops.map(obj => {
  //                     if (obj.season == "RABI") {
  //                       let rObj = {}

  //                       rObj["name"] = obj.crop_name;
  //                       rObj["id"] = obj.id;
  //                       rObj["rainfed"] = obj.rainfed;
  //                       rObj["irrigated"] = obj.irrigated;

  //                       return rObj
  //                     }

  //                   })
  //                   // debugger
  //                   this.rabiCropListNew2 = reformattedArrayRabi.filter(Boolean //CROPS for MP Rabi
  //                   ).filter((r) => r.name != "-");
  //                   console.log(this.rabiCropListNew2)

  //                 }
  //                 else {
  //                   this.rabiCropListNew2 = []
  //                   this.snackbar.open('No Rabi crops found', 'OK', { duration: 3000 })
  //                 }

  //                 if (crops.length > 0) {
  //                   let reformattedArrayKharif = crops.map(obj => {
  //                     let rObj = {}

  //                     rObj["name"] = obj.crop_name;
  //                     rObj["id"] = obj.id;
  //                     rObj["rainfed"] = obj.rainfed;
  //                     rObj["irrigated"] = obj.irrigated;

  //                     return rObj
  //                   })
  //                   console.log(this.rabiCropListNew2)
  //                   this.kharifCropListNew2 = reformattedArrayKharif.filter(  //CROPS for MP Rabi
  //                     (r) => r.name != "-"
  //                   );
  //                 } else {
  //                   this.kharifCropListNew2 = []
  //                   this.snackbar.open('No Kharif crops found', 'OK', { duration: 3000 })
  //                 }

  //               });
  //             }



  //           } else {
  //             this.landRecordStatus = false;
  //             this.consentFormText = "Please fill the Land Details for the customer."
  //             this.snackbar.open("No added land records found", "OK", { duration: 3000 })
  //           }
  //         }, (err) => {
  //           this.snackbar.open("Failed to fetch land records information.", "OK", { duration: 3000 })
  //         })


  //       } else {
  //         this.snackbar.open("Applicant data not found.", "OK", { duration: 3000 });
  //       }

  //     }, (err) => {
  //       this.snackbar.open("Failed to fetch details. Please try again later", "OK", { duration: 3000 })
  //     });

  // }

  async ngOnInit() {

    await this.applicant.getLoanAmountStrings().subscribe((resp)=>{

      sessionStorage.setItem('loanAmounts',JSON.stringify(resp))
      this.loanAmountInNumbers = JSON.parse(sessionStorage.getItem('loanAmounts')).LOAN_LIMIT;
      this.loanAmountInDecimals = JSON.parse(sessionStorage.getItem('loanAmounts')).LOAN_LIMIT_DECIMAL;
    },(err)=>{
      this.router.navigate(['/no_page'])
    })
    
    this.loading = true;
    this.setStateValuesOnLoad();
    let continueToFillForm = await this.fetchLandDetails();

    let continueToCheckStatuses;
    if (continueToFillForm) {
      continueToCheckStatuses = await this.fetchFormDataNpatch();
    } else {
      this.loading = false;
      this.snackbar.open(constants.NO_LAND_FOUND, "OK", { duration: 5000 })
      return
    }

    let checksDone;
    if (continueToCheckStatuses) {
      checksDone = await this.fetchOverallStatusAndCreditData();
      console.log(checksDone, "credit n status")
    } else {
      this.loading = false;
      this.snackbar.open(constants.UNABLE_TO_FETCH_CONSENTDATA, "OK", { duration: 5000 })
      return
    }

    // debugger
    if (checksDone) {
      await this.fetchCrops(this.fetchLandsResponse);
      this.finalFormSubmissionLogic(this.consentformdata);
    } else {
      this.snackbar.open("Failed in BRE check.", "OK")
    }

    this.multiCropDetailsForm.valueChanges.pipe(
      debounceTime(800),
      distinctUntilChanged()
    ).subscribe(newValue => {
      console.log(newValue, this.multiCropDetailsForm)
      // this.totalLandArea = 5

      if (newValue && newValue.cropArrayKharif) {
        let totalKharif = 0;
        for (let i = 0; i < newValue.cropArrayKharif.length; i++) {
          totalKharif = totalKharif + newValue.cropArrayKharif[i].kharif_acres * 1 + (newValue.cropArrayKharif[i].kharif_guntas ? (newValue.cropArrayKharif[i].kharif_guntas) / 40 : 0);
        }
        console.log(totalKharif * 1)
        if (totalKharif * 1 > this.totalLandArea) {
          this.disableSubmitFromMulticrop = true
          // this.multiCropDetailsForm.controls['cropArrayKharif'].setErrors({'incorrect': true})
          // window.alert("Crop area in the selected season is greater than the available land area")


          const dialogRef = this.dialog.open(OpenDialogYesOrNo, {
            width: 'auto', height: 'auto',
            data: {
              content: `The total land area assigned for kharif season is exceeding the total land area as per land records (${this.totalLandArea} ${this.acreOrHectare}). Please enter the correct land area.`,
              content1: `खरीफ सीजन के लिए आवंटित कुल भूमि क्षेत्र भूमि रिकॉर्ड (${this.totalLandArea} हेक्टेयर) के अनुसार कुल भूमि क्षेत्र से अधिक है। कृपया सही भूमि क्षेत्र दर्ज करें।`, button1Text: "OK"
            }
          });

        } else if (totalKharif * 1 < this.totalLandArea && totalKharif != 0) {
          this.disableSubmitFromMulticrop = false;
          console.log('else condition')
          // this.multiCropDetailsForm.controls['cropArrayKharif'].setErrors({'incorrect': false})

        }
      }

      if (newValue && newValue.cropArrayRabi) {
        let totalRabi = 0;
        for (let i = 0; i < newValue.cropArrayRabi.length; i++) {
          totalRabi = totalRabi + newValue.cropArrayRabi[i].rabi_acres * 1 + (newValue.cropArrayRabi[i].rabi_gunta ? (newValue.cropArrayRabi[i].rabi_gunta) / 40 : 0);
        }
        console.log(totalRabi)
        if (totalRabi * 1 > this.totalLandArea) {
          // this.hideSubmit = true;
          console.log(totalRabi * 1 > this.totalLandArea)
          // window.alert("Crop area in the selected season is greater than the available land area")
          // this.multiCropDetailsForm.controls['cropArrayRabi'].setErrors({'incorrect': true})
          const dialogRef = this.dialog.open(OpenDialogYesOrNo, {
            width: 'auto', height: 'auto',
            data: {
              content: `The total land area assigned for rabi season is exceeding the total land area as per land records (${this.totalLandArea} ${this.acreOrHectare}). Please enter the correct land area.`,
              content1: `रबी सीजन के लिए आवंटित कुल भूमि क्षेत्र भूमि रिकॉर्ड (${this.totalLandArea} हेक्टेयर) के अनुसार कुल भूमि क्षेत्र से अधिक है। कृपया सही भूमि क्षेत्र दर्ज करें।`, button1Text: "OK"
            }
          });
        } else if (totalRabi * 1 < this.totalLandArea && totalRabi != 0) {
          // this.hideSubmit = false;
          // this.multiCropDetailsForm.controls['cropArrayKharif'].setErrors({'incorrect': false})

        }
      }

      if (newValue && newValue.cropArraySummer) {
        let totalSummer = 0;
        for (let i = 0; i < newValue.cropArraySummer.length; i++) {
          totalSummer = totalSummer + newValue.cropArraySummer[i].summer_acres * 1 + (newValue.cropArraySummer[i].summer_gunta ? (newValue.cropArrayRabi[i].summer_gunta) / 40 : 0);
        }
        console.log(totalSummer)
        if (totalSummer * 1 > this.totalLandArea) {
          console.log(totalSummer * 1 > this.totalLandArea)
          // window.alert("Crop area in the selected season is greater than the available land area")
          // this.multiCropDetailsForm.controls['cropArrayRabi'].setErrors({'incorrect': true})
          const dialogRef = this.dialog.open(OpenDialogYesOrNo, {
            width: 'auto', height: 'auto',
            data: {
              content: `The total land area assigned for summer season is exceeding the total land area as per land records (${this.totalLandArea} ${this.acreOrHectare}). Please enter the correct land area.`,
              content1: `रबी सीजन के लिए आवंटित कुल भूमि क्षेत्र भूमि रिकॉर्ड (${this.totalLandArea} हेक्टेयर) के अनुसार कुल भूमि क्षेत्र से अधिक है। कृपया सही भूमि क्षेत्र दर्ज करें।`, button1Text: "OK"
            }
          });
        } else if (totalSummer * 1 < this.totalLandArea && totalSummer != 0) {
          // this.multiCropDetailsForm.controls['cropArrayKharif'].setErrors({'incorrect': false})

        }
      }

      this.checkIfCropMatchesAndDisableSubmit(newValue);
    })
  }

  async fetchLandDetails() {
    try {
      const resp = await this.applicant.getLandDetails().toPromise();
      console.log(resp);
      this.fetchLandsResponse = resp;
      let totalArea = 0;
      if (resp && resp.files && resp.files.length && resp.files[0] && resp.files[0].district_eng) {
        this.district_ap = resp.files[0].district_eng
      }
      if (resp && resp.files) {

        if (resp && resp.landSubmitStatus && resp.landSubmitStatus == true) {
          console.log('if');
          this.landRecordStatus = true;
          
        } else {
          console.log('else');
          this.landRecordStatus = false;
          this.consentFormText = constants.LR_UPD_PENDING;
        }

        return true;

      } else {
        this.landRecordStatus = false;
        this.consentFormText = constants.PLS_FILL_LAND;
        this.snackbar.open(constants.NO_ADDED_LRS, "OK", { duration: 3000 })
        return false;
      }

    } catch (error) {
      this.snackbar.open(constants.LANDS_FETCH_API_FAIL, "OK", { duration: 3000 });
      return false;
    }
  }

  async fetchCrops(fetchLandsResponse) {
    try {
      this.loading = true;
      let totalArea = 0;
      let resp = fetchLandsResponse;
      if (this.showMPCroppingPattern && this.landRecordStatus) {
        for (let i = 0; i < resp.files.length; i++) {
          totalArea = totalArea + resp.files[i].land_details.landParcelDetails[0].surveyNoArea[0] * 1
        }

        this.totalLandArea = Math.round(totalArea * 100) / 100

        this.multiCropDetailsForm.controls['kharifTotal'].setValidators([Validators.max(this.totalLandArea)]);
        this.multiCropDetailsForm.controls['rabiTotal'].setValidators([Validators.max(this.totalLandArea)]);
        this.multiCropDetailsForm.controls['summerTotal'].setValidators([Validators.max(this.totalLandArea)]);

        console.log(this.totalLandArea, "total land area *******")

        let distid
        distid = resp.files[0] && resp.files[0].DistId ? resp.files[0].DistId : ""
        let data = { distId: distid }
        this.applicant.getcropsdataDistId(data).subscribe((res) => {
          this.loading = false;
          console.log(res, "ressssssssssssssssssssss");
          this.loading = false
          this.crops = res;
          this.rabiCropList = res.rabi;
          this.kharifCropList = res.kharif;
          console.log(this.rabiCropList, this.kharifCropList);
          if (this.rabiCropList.length > 0) {

            let reformattedArrayRabi = this.rabiCropList.map(obj => {
              let rObj = {}

              rObj["name"] = obj.crop_name;
              rObj["id"] = obj.id;
              rObj["rainfed"] = obj.rainfed;
              rObj["irrigated"] = obj.irrigated;

              return rObj
            })
            console.log(this.rabiCropListNew2)
            this.rabiCropListNew2 = reformattedArrayRabi.filter(  //CROPS for MP Rabi
              (r) => r.name != "-"
            );
          } else {
            this.rabiCropListNew2 = []
            this.snackbar.open(constants.NO_RABI, 'OK', { duration: 3000 })
          }

          if (this.kharifCropList.length > 0) {
            let reformattedArrayKharif = this.kharifCropList.map(obj => {
              let rObj = {}

              rObj["name"] = obj.crop_name;
              rObj["id"] = obj.id;
              rObj["rainfed"] = obj.rainfed;
              rObj["irrigated"] = obj.irrigated;

              return rObj
            })
            console.log(this.rabiCropListNew2)
            this.kharifCropListNew2 = reformattedArrayKharif.filter(  //CROPS for MP Rabi
              (r) => r.name != "-"
            );
          } else {
            this.kharifCropListNew2 = []
            this.snackbar.open(constants.NO_KHARIF, 'OK', { duration: 3000 })
          }
          return true;

        });
      }

      if (this.loadKACrops && this.landRecordStatus) {
        for (let i = 0; i < resp.files.length; i++) {
          totalArea = totalArea + resp.files[i].bhoomi_details.Landdata[0].ExtAcre * 1 + resp.files[i].bhoomi_details.Landdata[0].ExtGunta / 40;
        }

        this.totalLandArea = Math.round(totalArea * 100) / 100

        this.multiCropDetailsForm.controls['kharifTotal'].setValidators([Validators.max(this.totalLandArea)]);
        this.multiCropDetailsForm.controls['rabiTotal'].setValidators([Validators.max(this.totalLandArea)]);
        this.multiCropDetailsForm.controls['summerTotal'].setValidators([Validators.max(this.totalLandArea)]);

        console.log(this.totalLandArea, "total land area *******")

        let distid
        distid = resp && resp.files && resp.files[0] && resp.files[0].bhoomi_details && resp.files[0].bhoomi_details.Landdata && resp.files[0].bhoomi_details.Landdata[0] && resp.files[0].bhoomi_details.Landdata[0].DistrictName ? resp.files[0].bhoomi_details.Landdata[0].DistrictName : "";

        this.multiCropDetailsForm.controls['kharifTotal'].setValidators([Validators.max(this.totalLandArea)]);
        this.multiCropDetailsForm.controls['rabiTotal'].setValidators([Validators.max(this.totalLandArea)]);
        this.multiCropDetailsForm.controls['summerTotal'].setValidators([Validators.max(this.totalLandArea)]);

        if (distid) {
          let data = { distId: distid }
          this.applicant.getcropsdataDistId(data).subscribe((res) => {
            this.loading = false;
            console.log(res, "ressssssssssssssssssssss");
            // res = cropsResp;
            // res = cropsfromuat;
            this.loading = false
            this.crops = res;
            this.rabiCropList = res.rabi;
            this.kharifCropList = res.kharif;
            console.log(this.rabiCropList, this.kharifCropList);
            if (this.rabiCropList.length > 0) {
              let reformattedArrayRabi = this.rabiCropList.map(obj => {
                let rObj = {}

                rObj["name"] = obj.crop_name;
                rObj["id"] = obj.id;
                rObj["rainfed"] = obj.rainfed;
                rObj["irrigated"] = obj.irrigated;

                return rObj
              })
              console.log(this.rabiCropListNew2)
              this.rabiCropListNew2 = reformattedArrayRabi.filter(  //CROPS for MP Rabi
                (r) => r.name != "-"
              );

            } else {
              this.rabiCropListNew2 = []
              this.snackbar.open(constants.NO_RABI, 'OK', { duration: 3000 })
            }

            if (this.kharifCropList.length > 0) {
              let reformattedArrayKharif = this.kharifCropList.map(obj => {
                let rObj = {}

                rObj["name"] = obj.crop_name;
                rObj["id"] = obj.id;
                rObj["rainfed"] = obj.rainfed;
                rObj["irrigated"] = obj.irrigated;

                return rObj
              })
              console.log(this.rabiCropListNew2)
              this.kharifCropListNew2 = reformattedArrayKharif.filter(  //CROPS for MP Rabi
                (r) => r.name != "-"
              );
            } else {
              this.kharifCropListNew2 = []
              this.snackbar.open(constants.NO_KHARIF, 'OK', { duration: 3000 })
            }
            return true;

          });
        } else {

          this.snackbar.open( constants.DIST_INFO_MISSING, "OK", { duration: 3000 })
          return false;
        }

      }

      if (this.loadAPCrops && this.landRecordStatus && this.district_ap) {
        console.log('ap da')
        for (let i = 0; i < resp.files.length; i++) {
          totalArea = totalArea + resp.files[i].landParcelDetails[0].Total_Extent * 1
        }

        this.totalLandArea = Math.round(totalArea * 100) / 100

        this.multiCropDetailsForm.controls['kharifTotal'].setValidators([Validators.max(this.totalLandArea)]);
        this.multiCropDetailsForm.controls['rabiTotal'].setValidators([Validators.max(this.totalLandArea)]);
        this.multiCropDetailsForm.controls['summerTotal'].setValidators([Validators.max(this.totalLandArea)]);

        console.log(this.totalLandArea, "total land area *******")
        let distid
        distid = resp && resp.files && resp.files[0] && resp.files[0].DistId ? resp.files[0].DistId : "";
        let data = { distId: this.district_ap }
        // this.applicant.getcropsdataDistId(data).subscribe((res) => {
        this.applicant.getCropsList(data).subscribe((res) => {
          console.log(res, "ressssssssssssssssssssss");

          this.loading = false

          let crops = res && res.crops_list ? res.crops_list : "";
          this.rabiCropList = crops.filter((crop) => {
            return crop.season == "RABI"
          })
          this.kharifCropList = crops.filter((crop) => {
            return crop.season == "KHARIF"
          })
          // if (this.rabiCropList != null) {
          if (crops.length > 0) {
            let reformattedArrayRabi = crops.map(obj => {
              if (obj.season == "RABI") {
                let rObj = {}

                rObj["name"] = obj.crop_name;
                rObj["id"] = obj.id;
                rObj["rainfed"] = obj.rainfed;
                rObj["irrigated"] = obj.irrigated;

                return rObj
              }

            })
            // debugger
            this.rabiCropListNew2 = reformattedArrayRabi.filter(Boolean //CROPS for MP Rabi
            ).filter((r) => r.name != "-");
            console.log(this.rabiCropListNew2)

          }
          else {
            this.rabiCropListNew2 = []
            this.snackbar.open(constants.NO_RABI, 'OK', { duration: 3000 })
          }

          if (crops.length > 0) {
            let reformattedArrayKharif = crops.map(obj => {
              let rObj = {}

              rObj["name"] = obj.crop_name;
              rObj["id"] = obj.id;
              rObj["rainfed"] = obj.rainfed;
              rObj["irrigated"] = obj.irrigated;

              return rObj
            })
            console.log(this.rabiCropListNew2)
            this.kharifCropListNew2 = reformattedArrayKharif.filter(  //CROPS for MP Rabi
              (r) => r.name != "-"
            );
          } else {
            this.kharifCropListNew2 = []
            this.snackbar.open(constants.NO_KHARIF, 'OK', { duration: 3000 })
          }

        });
      }
    } catch (err){
      this.snackbar.open(constants.FAILED_TO_FETCH_CROPS, "OK")
    }
  }

  async fetchFormDataNpatch() {
    try {

      this.consentformdata = await this.applicant
        .getconsentformdata({ applicantId: sessionStorage.getItem('wl-applicant-id') }).toPromise();
      const resp = this.consentformdata;
      this.loading = false;
      console.log(
        "response from getconsentformdata 54645" + JSON.stringify(resp), resp
      );
      if (resp && resp.success) {

        if(resp && resp.result && resp.result.consent_update_status && resp.result.consent_update_status === true){
          this.disableSubmitConsentAlreadySubmitted = true;
          this.consentUpdateStatus = resp.result.consent_update_status;
        }else{
          this.snackbar.open(constants.PLS_SUBMIT_CONSENT_FORM, "OK", { duration: 3000 });
        }

        let user_docs = resp && resp.result && resp.result.user_docs ? resp.result.user_docs : null;
        let resp_cropping_pattern = resp && resp.result && resp.result.cropping_pattern ? resp.result.cropping_pattern : null;
        let croppingPattern = resp && resp.result && resp.result.cropping_pattern ? resp.result.cropping_pattern : null;
        this.resp_cropping_pattern = resp_cropping_pattern
        let consentFd_resp_result = resp.result;


        if (user_docs && user_docs.existing_loan_details && user_docs.existing_loan_details.existing_limit) {
          this.existing_limit = user_docs.existing_loan_details.existing_limit;
        }
        if (user_docs && user_docs.kcc_acc_no_referencenumber) {
          this.accNoUnmasked = user_docs.kcc_acc_no_referencenumber;
        }

        if (user_docs && user_docs.custId) {
          this.custId = user_docs.custId;
        }

        if (resp && resp.result && resp.result.cropping_pattern && resp.result.cropping_pattern[0] && resp.result.cropping_pattern[0].crop_data) {
          for (let i = 0; i < resp_cropping_pattern[0].crop_data.length; i++) {
            if (resp_cropping_pattern && resp_cropping_pattern[0] && resp_cropping_pattern[0].crop_data && resp_cropping_pattern[0].crop_data[i] && resp_cropping_pattern[0].crop_data[i].name_of_the_crop) {
              (this.multiCropDetailsForm.controls.cropArrayKharif as UntypedFormArray).push(this.fb.group({
                kharif: [resp_cropping_pattern[0].crop_data[i].name_of_the_crop.crop_name ? resp_cropping_pattern[0].crop_data[i].name_of_the_crop.crop_name : ""],
                kharifId: [resp_cropping_pattern[0].crop_data[i].name_of_the_crop.id ? resp_cropping_pattern[0].crop_data[i].name_of_the_crop.id : ""],
                kharif_acres: [resp_cropping_pattern[0].crop_data[i].acres ? resp_cropping_pattern[0].crop_data[i].acres : ""],
                kharif_guntas: [resp_cropping_pattern[0].crop_data[i].guntas ? resp_cropping_pattern[0].crop_data[i].guntas : ""],
              }))
            }
          }
        }

        if (resp && resp.result && resp.result.cropping_pattern && resp.result.cropping_pattern[1] && resp.result.cropping_pattern[1].crop_data) {
          for (let i = 0; i < resp_cropping_pattern[1].crop_data.length; i++) {
            if (resp_cropping_pattern && resp_cropping_pattern[1] && resp_cropping_pattern[1].crop_data && resp_cropping_pattern[1].crop_data[i] && resp_cropping_pattern[1].crop_data[i].name_of_the_crop) {
              (this.multiCropDetailsForm.controls.cropArrayRabi as UntypedFormArray).push(this.fb.group({
                rabi: [resp_cropping_pattern[1].crop_data[i].name_of_the_crop.crop_name ? resp_cropping_pattern[1].crop_data[i].name_of_the_crop.crop_name : ""],
                rabiId: [resp_cropping_pattern[1].crop_data[i].name_of_the_crop.id ? resp_cropping_pattern[1].crop_data[i].name_of_the_crop.id : ""],
                rabi_acres: [resp_cropping_pattern[1].crop_data[i].acres ? resp_cropping_pattern[1].crop_data[i].acres : ""],
                rabi_gunta: [resp_cropping_pattern[1].crop_data[i].guntas ? resp_cropping_pattern[1].crop_data[i].guntas : ""],
              }))
            }
          }
        }

        if (resp && resp.result && resp.result.cropping_pattern && resp.result.cropping_pattern[2] && resp.result.cropping_pattern[2].crop_data) {
          for (let i = 0; i < resp_cropping_pattern[2].crop_data.length; i++) {
            if (resp_cropping_pattern && resp_cropping_pattern[2] && resp_cropping_pattern[2].crop_data && resp_cropping_pattern[2].crop_data[i] && resp_cropping_pattern[2].crop_data[i].name_of_the_crop) {
              (this.multiCropDetailsForm.controls.cropArraySummer as UntypedFormArray).push(this.fb.group({
                summer: [resp_cropping_pattern[2].crop_data[i].name_of_the_crop.crop_name ? resp_cropping_pattern[2].crop_data[i].name_of_the_crop.crop_name : ""],
                summerId: [resp_cropping_pattern[2].crop_data[i].name_of_the_crop.id ? resp_cropping_pattern[2].crop_data[i].name_of_the_crop.id : ""],
                summer_acres: [resp_cropping_pattern[2].crop_data[i].acres ? resp_cropping_pattern[2].crop_data[i].acres : ""],
                summer_gunta: [resp_cropping_pattern[2].crop_data[i].guntas ? resp_cropping_pattern[2].crop_data[i].guntas : ""],
              }))
            }
          }
        }


        this.totalacres();
        { // patching values only here'
          console.log(resp.result.user_docs)
          this.bankAccForm.patchValue({
            name_of_borrower: user_docs.applicant_name ? user_docs.applicant_name : "",
          });
          this.bankAccForm.patchValue({
            name_of_co_applicant: (resp.result.user_docs.coapplicant_data && resp.result.user_docs.coapplicant_data.name)
              ? resp.result.user_docs.coapplicant_data.name
              : "",
          });
          this.bankAccForm.patchValue({
            bank_acc_no: user_docs.kcc_acc_no ? user_docs.kcc_acc_no : "",
          });
          this.bankAccForm.patchValue({
            corps_address: user_docs.resAdd ? user_docs.resAdd.address + ', ' + user_docs.resAdd.state + ', ' + user_docs.resAdd.postal_code : "",
          });
          this.bankAccForm.patchValue({
            customer_id: user_docs.custId ? user_docs.custId : "",
          });
          this.bankAccForm.patchValue({
            due_date_of_renew: user_docs.renewal_duedate_for_credit_limit
              ? user_docs.renewal_duedate_for_credit_limit
              : "",
          });
          this.bankAccForm.patchValue({
            type_of_facility: user_docs.existing_loan_details.type_of_facility
              ? user_docs.existing_loan_details.type_of_facility
              : "",
          });
          this.bankAccForm.patchValue({
            existing_loan_in_lakhs: user_docs.existing_dp
              ? user_docs.existing_dp
              : "",
          });
          this.bankAccForm.patchValue({
            outstanding_as_on: user_docs.existing_loan_details.outstanding_as_on
              ? user_docs.existing_loan_details.outstanding_as_on
              : 0,
          });
          this.bankAccForm.patchValue({
            roi: user_docs.existing_loan_details.roi
              ? user_docs.existing_loan_details.roi
              : "",
            rate_of_interest: user_docs.existing_loan_details.roi
              ? user_docs.existing_loan_details.roi
              : ""
          });
          this.bankAccForm.patchValue({
            margin: user_docs.existing_loan_details.margin
              ? user_docs.existing_loan_details.margin
              : "",
            minimum_margin: user_docs.existing_loan_details.margin
              ? user_docs.existing_loan_details.margin
              : "",
          });
          this.bankAccForm.patchValue({
            type_of_facilities:
              user_docs.existing_loan_details && user_docs.existing_loan_details.type_of_facility
                ? user_docs.existing_loan_details.type_of_facility
                : "",
          });

          this.bankAccForm.patchValue({
            securities: "Hypothecation of Standing Crops and other Securities as per existing terms of sanction.",
          });
          this.bankAccForm.patchValue({
            kcc_loanamt_cbs:
              user_docs.existing_dp
                ? user_docs.existing_dp
                : "",
          });
          this.bankAccForm.patchValue({
            is_renewal_kcc_limit_required: consentFd_resp_result.is_renewal_kcc_limit_required && (consentFd_resp_result.is_renewal_kcc_limit_required != "pending")
              ? consentFd_resp_result.is_renewal_kcc_limit_required
              : "yes",
          });
          this.bankAccForm.patchValue({
            is_cropping_insurance_required: consentFd_resp_result.is_cropping_insurance_required && (consentFd_resp_result.is_cropping_insurance_required != "pending")
              ? consentFd_resp_result.is_cropping_insurance_required
              : "yes",
          });

        }
        this.loanAmountAsPerCbs = user_docs.existing_dp
          ? user_docs.existing_dp
          : "";

        console.log(resp_cropping_pattern, "resp_cropping_pattern");
        return true;

      } else {
        this.snackbar.open(constants.APPLI_DATA_NOT_FOUND, "OK", { duration: 3000 });
        return false;
      }

    } catch (err) {
      this.snackbar.open(constants.APPL_DATA_FETCH_FAILS, "OK", { duration: 3000 })
      return false;
    }

  }

  async fetchOverallStatusAndCreditData() {
    try {
      const resp = await this.applicant.getOverAllStatus().toPromise();
      console.log(resp);
      this.loading = true;
      this.overAllStatus = resp;

      if (resp && resp.data && resp.data.landDetails) {
        if (resp.data && resp.data.cicReport === false) {
          let creditDone = await this.fetchCreditData();
          if(!creditDone){
            this.openCreditDataModal(constants.CREDIT_CHECK_FAIL)
          }
          let bre = await this.checkBreStatus();
          return bre;
        }else{
          let bre = await this.checkBreStatus();
          return bre;
        }
      } else {
        this.loading = false;
        this.consentFormText = constants.PLS_FILL_LAND;
        this.landRecordStatus = false;
      }
    } catch (error) {
      console.error("Failed to fetch overall status and credit data:", error);
      this.snackbar.open(constants.OVERALL_STATUS_FETCH_FAILED, "OK", { duration: 3000 });
    }
  }

  async fetchCreditData() {
    try {
      const resp = await this.applicant.getCreditData(this.stateCode, this.repeatGetCreditScoreAPICount).toPromise();
      console.log("getcreditdata ---> API", resp);
      if (this.repeatGetCreditScoreAPICount == 3) {
        return false;
      }
      
      if (resp && resp.success === true && (resp.message === "Report Generated Successfully" || resp.message === "Credit Report fetched successfully")) {
        this.loading = false;
        // debugger
        if (resp.npaStatusFlag && resp.npaStatusFlag === true) {
          this.openCreditDataModal(constants.NPA_FOUND);
        } else {
          let bre = await this.checkBreStatus();
          // debugger
          return bre;
        }
      } else {
        this.repeatGetCreditScoreAPICount += 1;
        this.loading = true;
        await this.fetchCreditData(); // Recursive call to retry fetching credit data
      }
    } catch (error) {
      console.error("Failed to fetch credit data:", error);
      this.snackbar.open(constants.FAILED_TOFETCH_REPORT, "OK", { duration: 3000 });
      return false;
    }
  }

  async checkBreStatus() {
    try {
      const result = await this.creditreport.getBreStatus().toPromise();
      console.log(result);
      this.loading = false;

      if (result === "Failure" || result === "failure") {
        this.consentFormText = constants.MOVED_TO_FAILUREBX;
        this.landRecordStatus = false;
        return false;
      } else if (result === "pending" || result === "Pending") {
        this.consentFormText = constants.PLS_GENERATED_CREDIT;
        this.landRecordStatus = false;
        return false;
      }else{
        return true;
      }
    } catch (error) {
      console.error(constants.FAILED_BRE_FETCH, error);
      this.snackbar.open(constants.FAILED_BRE_FETCH, "OK", { duration: 3000 });
      return false;
    }
  }

  finalFormSubmissionLogic(resp) {
    try {

      if (resp && resp.result && resp.result.consent_update_status && resp.result.consent_update_status == true) {
        // this.disableSubmitConsentAlreadySubmitted = true;
        if (resp && resp.result && resp.result.sent_to_cbs && resp.result.sent_to_cbs == true) {
          this.disableSentToCbsAlready = true;
        } else {
          if (resp && resp.result && resp.result.final_form_submitted_status && resp.result.final_form_submitted_status.toLowerCase() == "yes") {
            if (resp && resp.result && resp.result.assesment_status && resp.result.assesment_status.toLowerCase() == "success") {
              this.getApplicantLoanFinalData(false);
            } else if (resp && resp.result && resp.result.assesment_status && resp.result.assesment_status.toLowerCase() == "failure") {
              this.disableFailureInAssessmentStatus = true;
              this.snackbar.open(constants.ASS_FAILURE_MOVED_TO_FAILURE, "OK", { duration: 3000 })
            } else if (resp && resp.result && resp.result.assesment_status && resp.result.assesment_status.toLowerCase() == "pending") {
              this.getApplicantLoanFinalData(true);
            }
          } else if ((resp.result.final_form_submitted_status.toLowerCase() == "no") || (resp.result.final_form_submitted_status.toLowerCase() == "pending")) {
            this.getApplicantLoanFinalData(true);
          }
        }
      } else {
        // this.snackbar.open("Please submit the consent form", "OK", { duration: 3000 })
        this.consentUpdateStatus = false;
      }
    } catch (err){
      this.snackbar.open(constants.SOMETHING_WENT_WRONG,"OK",{duration:5000})
    }
  }

  setStateValuesOnLoad() {
    let stateValue = sessionStorage.getItem('wEnlw3OeU3')

    if (stateValue == "xmpHUKBVNVSFG61XnJAzKOQ32EWjSdE1") {
      this.acreOrHectare = "Hectare"
      this.stateCode = "MP"
    } else if (stateValue == "KDw2nS6vb5cJ286KJ3JwtGKGnnnLO93Y") {
      this.acreOrHectare = "Acre"
      this.stateCode = "KA"
    } else if (stateValue == "X0ZUk5Z7otQSnJFm9rc2bcAvwPrp66i6") {
      this.acreOrHectare = "Acre"
      this.stateCode = "AP"
    }

    if (stateValue == "xmpHUKBVNVSFG61XnJAzKOQ32EWjSdE1") {
      this.acreOrHectare = "Hectare"
      this.showGuntas = false
      this.showMPCroppingPattern = true

    } else if (stateValue == "KDw2nS6vb5cJ286KJ3JwtGKGnnnLO93Y") {
      this.acreOrHectare = "Acre"
      this.showGuntas = true
      this.showMPCroppingPattern = false
      this.loadKACrops = true;

    } else if (stateValue == "X0ZUk5Z7otQSnJFm9rc2bcAvwPrp66i6") {
      this.acreOrHectare = "Acre"
      this.showGuntas = true
      this.showMPCroppingPattern = false;
      this.loadAPCrops = true;

    }

    this.role = sessionStorage.getItem("wzbvdsjvbbs");
    if (this.role === "5b8f43f6-9ae5-4642-8939-310771661e4f") {
      this.roleId = 5;
      // this.maker_checker_flag = false;
    }
  }

  getApplicantID() {
    return sessionStorage.getItem("wl-applicant-id");
  }

  totalacres() {
    let acresN1 = 0;
    let guntasN1 = 0;
    let acresN2 = 0;
    let guntasN2 = 0;
    let acresN3 = 0;
    let guntasN3 = 0;
    const myForm = this.multiCropDetailsForm.getRawValue();
    console.warn(myForm, "myform");
    const kharifdata = myForm.cropArrayKharif;
    const rabidata = myForm.cropArrayRabi;
    const summerdata = myForm.cropArraySummer;
    kharifdata.map(value => {
      acresN1 = acresN1 + (value.kharif_acres ? value.kharif_acres * 1 : 0);
      guntasN1 = guntasN1 + (value.kharif_guntas ? value.kharif_guntas * 1 : 0);
    })
    rabidata.map(value => {
      acresN2 = acresN2 + (value.rabi_acres ? value.rabi_acres * 1 : 0);
      guntasN2 = guntasN2 + (value.rabi_gunta ? value.rabi_gunta * 1 : 0);
    })
    summerdata.map(value => {
      acresN3 = acresN3 + (value.summer_acres ? value.summer_acres * 1 : 0);
      guntasN3 = guntasN3 + (value.summer_gunta ? value.summer_gunta * 1 : 0);
    })

    this.hectaresKharif = acresN1
    this.hectaresRabi = acresN2
    this.hectaresSummer = acresN3

    this.acressum = acresN1 + acresN2 + acresN3;

    this.guntassum = guntasN1 + guntasN2 + guntasN3;

    this.returnacres(this.guntassum, this.acressum);

  }

  returnacres(guntas, sumofacres) {
    console.log(guntas, 'guntas');
    console.log(sumofacres, 'sumofacres');
    let acres = Math.floor(guntas / 40);
    let remainGuntas = guntas % 40;
    let totalAcres = acres + sumofacres + " acres ";
    let totalAcres1 = acres + sumofacres;
    if (remainGuntas < 10) {
      totalAcres = totalAcres + "0" + remainGuntas + " Guntas";
    } else {
      totalAcres = totalAcres + remainGuntas + " Guntas";
    }
    console.log(totalAcres, 'totalacres');
    this.acresum = totalAcres;

    if (!this.showMPCroppingPattern) {
      this.acressumnum = totalAcres1 + (remainGuntas * 0.01) / .4;
    } else {
      this.acressumnum = totalAcres1 + (remainGuntas * 0.01);
    }


  }


  returnacres1(guntas, sumofacres) {
    console.log(guntas, 'guntas');
    console.log(sumofacres, 'sumofacres');
    let acres = Math.floor(guntas / 40);
    let remainGuntas = guntas % 40;
    let totalAcres = acres + sumofacres + " acres ";
    let totalAcres1 = acres + sumofacres;
    if (remainGuntas < 10) {
      totalAcres = totalAcres + "0" + remainGuntas + " Guntas";
    } else {
      totalAcres = totalAcres + remainGuntas + " Guntas";
    }
    return totalAcres1 + (remainGuntas * 0.01);
  }

  consentformSubmit() {
    const formdata = this.multiCropDetailsForm.getRawValue();
    let formdata1 = this.bankAccForm.getRawValue();
    console.warn(formdata, "formmmmmmmm");
    console.warn(this.multiCropDetailsForm, "formmmmmmmm");
    // debugger
    const kharifdata = formdata.cropArrayKharif;
    const rabidata = formdata.cropArrayRabi;
    const summerdata = formdata.cropArraySummer;
    sessionStorage.setItem("submitted", "submitted");
    let khariffinaldata = [];
    let rabifinaldata = [];
    let summerfinaldata = [];

    if(kharifdata && kharifdata.length){
      kharifdata.map(value => {
        khariffinaldata.push({
          name_of_the_crop: this.objectFindByKey(this.kharifCropList, "id", value.kharifId),
          acrestotal: this.returnacres1(value.kharif_guntas ? value.kharif_guntas * 1 : 0, value.kharif_acres ? value.kharif_acres * 1 : 0),
          acres: value.kharif_acres ? value.kharif_acres * 1 : 0,
          guntas: value.kharif_guntas ? value.kharif_guntas * 1 : 0,
          total_area: formdata.acressumnum ? formdata.acressumnum * 1 : 0
        })
      })
    }

    if(rabidata && rabidata.length){
      rabidata.map(value => {
        rabifinaldata.push({
          name_of_the_crop: this.objectFindByKey(this.rabiCropList, "id", value.rabiId),
          acrestotal: this.returnacres1(value.rabi_gunta ? value.rabi_gunta * 1 : 0, value.rabi_acres ? value.rabi_acres * 1 : 0),
          acres: value.rabi_acres ? value.rabi_acres * 1 : 0,
          guntas: value.rabi_gunta ? value.rabi_gunta * 1 : 0,
          total_area: formdata.acressumnum ? formdata.acressumnum * 1 : 0
        })
      })
    }

    if(summerdata && summerdata.length){
      summerdata.map(value => {
        summerfinaldata.push({
          name_of_the_crop: this.objectFindByKey(this.crops, "id", value.summerId),
          acrestotal: this.returnacres1(value.summer_gunta ? value.summer_gunta * 1 : 0, value.summer_acres ? value.summer_acres * 1 : 0),
          acres: value.summer_acres ? value.summer_acres * 1 : 0,
          guntas: value.summer_gunta ? value.summer_gunta * 1 : 0,
          total_area: formdata.acressumnum ? formdata.acressumnum * 1 : 0
        })
      })
    }

    this.cropping_pattern = [
      {
        crop_season: "kharif",
        crop_data: khariffinaldata
      },
      {
        crop_season: "Rabi",
        crop_data: rabifinaldata
      },
      {
        crop_season: "Summer",
        crop_data: summerfinaldata
      },
    ];
    let dataobj = {
      cropping_pattern: this.cropping_pattern,
      // proposed_amount: formdata1.kcc_loanamt_farmer,
      is_renewal_kcc_limit_required: formdata1.is_renewal_kcc_limit_required,
      is_cropping_insurance_required: formdata1.is_cropping_insurance_required,
    };

    this.loading = true;

    this.applicant.consentformSubmit(dataobj).subscribe((resp) => {
      console.log("resp " + JSON.stringify(resp));
      this.loading = false;
      if (resp) {

        if (resp.success && resp.message && resp.message == "success") {
          this.getApplicantLoanFinalData(true)
        } else if (resp.message == "Already updated the data") {
          this.getApplicantLoanFinalData(true)
        }

        this.bankAccForm.controls['declaration'].setValue(false)

        if (this.resp_cropping_pattern && this.resp_cropping_pattern[0] && this.resp_cropping_pattern[0].crop_data && this.resp_cropping_pattern[0].crop_data) {
          for (let i = 0; i < this.resp_cropping_pattern[0].crop_data.length; i++) {
            this.removeRowRabi(i)
          }
        }
        if (this.resp_cropping_pattern && this.resp_cropping_pattern[1] && this.resp_cropping_pattern[1].crop_data && this.resp_cropping_pattern[1].crop_data.length) {
          for (let i = 0; i < this.resp_cropping_pattern[1].crop_data.length; i++) {
            this.removeRowKharif(i)
          }
        }
        if (this.resp_cropping_pattern && this.resp_cropping_pattern[2] && this.resp_cropping_pattern[2].crop_data && this.resp_cropping_pattern[2].crop_data.length) {
          for (let i = 0; i < this.resp_cropping_pattern[2].crop_data.length; i++) {
            this.removeRowSummer(i)
          }
        }

        if (this.overAllStatus && this.overAllStatus.data && this.overAllStatus.data.satSureData == false) {
          let data = {
            appId: sessionStorage.getItem('wl-applicant-id'),
          }
          this.applicant.callSatsure(data).subscribe(resp => {
            console.log('callSatsureApi--->', resp);
          })
        }

        const dialogRef = this.dialog.open(OpenDialogYesOrNo, {
          width: 'auto', height: 'auto',
          data: { heading: "Report Submitted Successfully", content: resp.message == "success" ? constants.DYUWANNA_GEN_NOTHER_REPORT : resp.message + ', Do you want to stay on this page?', button1Text: "Yes", button2Text: "No" }
        });

        dialogRef.afterClosed().subscribe(res => {
          console.log(res)
          if (res == "close") {
            window.close()
          } else {
            // this.ngOnInit()
            this.router.navigateByUrl('/laas/bre-status', { skipLocationChange: true }).then(() => {
              this.router.navigate(['/laas/consent-form']);
            })
          }
        })
      }
    }, (err) => {
      this.loading = false;
      this.snackbar.open(constants.CONSENT_UPD_FAILURE, "OK", { duration: 3000 })
    });


    console.log(dataobj);
  }

  consent_form_hide() {
    var dialogRef: MatDialogRef<ConsentDisabledComponent>;
    dialogRef = this.dialog.open(ConsentDisabledComponent, {
      disableClose: true,
      height: "auto",
      width: "auto",
      data: {
        // mobile: "9946213542",
        // password: company.password,
        // roleId: resp.result.roleId
      },
    });

    dialogRef.afterClosed().subscribe((res) => {
      console.log("res " + JSON.stringify(res));
      if (res && res.data == "yes confirmed") {
        this.kcc_form_disable = true;
        let dataobj = {
          is_renewal_kcc_limit_required: "no",
        };
        this.applicant.consentformSubmit(dataobj).subscribe((resp) => {
          console.log("resp " + JSON.stringify(resp));
        }, (err) => {
          this.snackbar.open(constants.CONSENT_UPD_FAILURE, "OK", { duration: 3000 })
        });

      } else if (res && res.data == true) {
        this.yeskccrdbtn1 = "yes";
        this.bankAccForm.patchValue({is_renewal_kcc_limit_required:"yes"})
      }

    });

  }

  showkccform() {
    this.kcc_form_flag = true;
  }

  objectFindByKey(array, key, value) {
    for (var i = 0; i < array.length; i++) {
      if (array[i][key] === value) {
        return array[i];
      }
    }
    return null;
  }


  kharifSelectedEvent(event, i) {
    console.log(event, i, this.multiCropDetailsForm, this.multiCropDetailsForm.value.cropArrayKharif);
    let isTheCropAlreadyAdded = 1;
    this.multiCropDetailsForm.value.cropArrayKharif.forEach((item) => {
      if (item.kharif == event.name) {
        isTheCropAlreadyAdded += 1;
      }
    })
    if (isTheCropAlreadyAdded == 2) {
      const myForm = (<UntypedFormArray>this.multiCropDetailsForm.get('cropArrayKharif')).at(i);
      myForm.patchValue({ kharifId: event.id })
      this.kharifDisabled = false;
    } else if (isTheCropAlreadyAdded > 2) {
      this.snackbar.open(constants.SAME_CROP_CANT_ADD, "OK", { duration: 3000 });
      this.removeRowKharif(i);

    }
  }

  rabiSelectedEvent(event, i) {
    let isTheCropAlreadyAdded = 1;
    this.multiCropDetailsForm.value.cropArrayRabi.forEach((item) => {
      if (item.rabi == event.name) {
        isTheCropAlreadyAdded += 1;
      }
    })
    if (isTheCropAlreadyAdded == 2) {
      const myForm = (<UntypedFormArray>this.multiCropDetailsForm.get('cropArrayRabi')).at(i);
      myForm.patchValue({ rabiId: event.id })
      this.rabiDisabled = false;
    } else {
      this.snackbar.open(constants.SAME_CROP_CANT_ADD, "OK", { duration: 3000 });
      this.removeRowRabi(i);
    }
  }
  summerSelectedEvent(event, i) {
    let isTheCropAlreadyAdded = 1;
    this.multiCropDetailsForm.value.cropArraySummer.forEach((item) => {
      if (item.summer == event.name) {
        isTheCropAlreadyAdded += 1;
      }
    })

    if (isTheCropAlreadyAdded == 2) {
      const myForm = (<UntypedFormArray>this.multiCropDetailsForm.get('cropArraySummer')).at(i);
      myForm.patchValue({ summerId: event.id })
      this.summerDisabled = false;
    } else {
      this.snackbar.open(constants.SAME_CROP_CANT_ADD, "OK", { duration: 3000 });
      this.removeRowSummer(i);
    }
  }

  cropArrayKharif(): UntypedFormArray {
    return this.multiCropDetailsForm.get("cropArrayKharif") as UntypedFormArray
  }
  cropArrayRabi(): UntypedFormArray {
    return this.multiCropDetailsForm.get("cropArrayRabi") as UntypedFormArray
  }
  cropArraySummer(): UntypedFormArray {
    return this.multiCropDetailsForm.get("cropArraySummer") as UntypedFormArray
  }

  newCropArrayKharif(): UntypedFormGroup {
    return this.fb.group({
      kharif: ['', Validators.required],
      kharifId: ['', Validators.required],
      kharif_acres: '',
      kharif_guntas: '',
    },{ validator: atLeastOneFieldRequired('kharif_acres', 'kharif_guntas') })
  }

  // newCropArrayRabi(): FormGroup {
  //   return this.fb.group({
  //     rabi: '',
  //     rabiId: '',
  //     rabi_acres: '',
  //     rabi_gunta: '',
  //   })
  // }

  newCropArrayRabi(): UntypedFormGroup {
    return this.fb.group({
      rabi: ['', Validators.required],
      rabiId: ['', Validators.required],
      rabi_acres: '',
      rabi_gunta: '',
    },{ validator: atLeastOneFieldRequired('rabi_acres', 'rabi_gunta') })
  }

  newCropArraySummer(): UntypedFormGroup {
    return this.fb.group({
      summer: '',
      summerId: '',
      summer_acres: '',
      summer_gunta: '',
    })
  }

  addKharifCrop() {
    this.cropArrayKharif().push(this.newCropArrayKharif());
  }

  addRabiCrop() {
    this.cropArrayRabi().push(this.newCropArrayRabi());
  }

  addSummerCrop() {
    this.cropArraySummer().push(this.newCropArraySummer());
  }

  removeRowKharif(i) {
    this.cropArrayKharif().removeAt(i);
    this.totalacres();
  }
  removeRowRabi(i) {
    this.cropArrayRabi().removeAt(i);
    this.totalacres();
  }
  removeRowSummer(i) {
    this.cropArraySummer().removeAt(i);
    this.totalacres();
  }

  checkForEmpty() {
    let Kharif = this.bankAccForm.getRawValue().kharif;
    console.log(Kharif);
    if (Kharif && Kharif.length == '') {
      this.bankAccForm.patchValue({ kharif_acres: 0, kharif_guntas: 0 });
    }
  }

  generateReport() {
    this.isReportPending = true;
    this.applicant.getConsentReport().subscribe(report => {
      this.isReportPending = false;
      this.reportLink = 'data:application/pdf;base64,' + report;
      this.token = report.key;
    })
  }

  downloadPdf() {
    const downloadLink = document.createElement("a");
    const fileName = "Consent-Form.pdf";

    downloadLink.href = this.reportLink;
    downloadLink.download = fileName;

    downloadLink.click();
  }

  openCreditDataModal(reason) {
    this.disabledByCreditCheck = true;
    const dialogRef = this.dialog.open(OpenDialogYesOrNo, {
      width: 'auto', height: 'auto', disableClose: true,
      data: { content: reason, button1Text: "OK" }
    });
  }


}

export const myValidator = (field1, field2): ValidatorFn => (control: AbstractControl) => {
  if (control.get(field1).value != 0) {
    return null;
  }
  if (control.get(field2).value == "") {
    return { myValidator: { valid: false } };
  }
  return { myValidator: { valid: false } };
}


export function atLeastOneFieldRequired(field1: string, field2: string): ValidatorFn {
  return (control: AbstractControl): { [key: string]: boolean } | null => {
    const formGroup = control as UntypedFormGroup;
    const field1Value = formGroup.controls[field1] && formGroup.controls[field1].value;
    const field2Value = formGroup.controls[field2] && formGroup.controls[field2].value;

    if ((field1Value !== null && field1Value !== '') || (field2Value !== null && field2Value !== '')) {
      return null;
    }
    return { atLeastOneRequired: true };
  };
}